import React from "react";
import { CheckIcon, TargetIcon, InfoIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { volumes } from "../../data/content";
export function Volumes() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-308" data-mp="2wzgpl3bkxy45">
      <div className="mx-auto max-w-6xl" data-id="element-309" data-mp="2symzq4eku98m">
        <SectionHeading eyebrow="What’s inside Musculoskeletal Clinical Pathway™?" title="6 Practical Volumes to Help You Organize Your Clinical Assessment" data-id="element-310" data-mp="2t1ra5jimy17q" />

        <div className="mt-12 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-311" data-mp="2j8k9ud2r5bei">
          {volumes.map(v => <article key={v.label} className="flex flex-col rounded-3xl border border-line bg-white p-6 shadow-card sm:p-8" data-id="element-312" data-mp="2eb204kgwus5g">
              <span className="self-start rounded-lg px-3 py-1.5 font-display text-sm font-black uppercase tracking-wider text-white" style={{
            backgroundColor: v.accent
          }} data-id="element-313" data-mp="25a416glbxatq">
                {v.label}
              </span>
              <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight text-ink sm:text-[28px]" data-id="element-314" data-mp="334bab91y99ug">{v.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-315" data-mp="37y72tvzg24i8">{v.intro}</p>

              <p className="mt-5 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-316" data-mp="2u2v1h5qs9fsc">Inside, you’ll explore:</p>
              <ul className="mt-3 space-y-2.5" data-id="element-317" data-mp="2y46r3b9nq10j">
                {v.bullets.map(b => <li key={b} className="flex gap-2.5 text-base leading-snug text-ink" data-id="element-318" data-mp="3lu188510ebql">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                color: v.accent
              }} aria-hidden="true" data-id="element-319" data-mp="3qufbzavkuzit" />
                    {b}
                  </li>)}
              </ul>

              {v.note && <p className="mt-5 flex gap-2 text-sm italic leading-relaxed text-muted" data-id="element-320" data-mp="21gacgbxs5fry">
                  <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-321" data-mp="26fdfxry43dxt" />
                  {v.note}
                </p>}

              <div className="mt-auto pt-6" data-id="element-322" data-mp="by3pak3l7yap">
                <div className="flex gap-3 rounded-2xl p-4" style={{
              backgroundColor: `${v.accent}14`
            }} data-id="element-323" data-mp="c0zjbxcbe2tv">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                color: v.accent
              }} aria-hidden="true" data-id="element-324" data-mp="29bzoim01q2y" />
                  <p className="text-base leading-relaxed text-ink" data-id="element-325" data-mp="3ude9xbxivflm">
                    <strong data-id="element-326" data-mp="3ubbjiqsgjkgd">The goal:</strong> {v.goal}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta label="Yes, I Want All 6 Volumes" data-id="element-327" data-mp="3ke6w6nmvlixz" />
      </div>
    </section>;
}